const SECTIONS = [
  {
    h: "1. Information We Collect",
    p: "We collect (a) Information you provide directly — name, email, phone, business details, payment information, application content, and any other data you submit via forms; (b) Information collected automatically — IP address, device and browser type, pages viewed, referring URL, and similar telemetry; (c) Information from third parties — payment processors (Stripe), email infrastructure (Resend), analytics, and lender data partners.",
  },
  {
    h: "2. How We Use Information",
    p: "To deliver and improve our services; to process applications and payments; to generate AI funding analyses and lender matching; to send editorial newsletters and transactional communications; to comply with legal obligations; to detect, investigate, and prevent fraud or abuse.",
  },
  {
    h: "3. Legal Bases (EU/UK Users)",
    p: "For users in the European Union and United Kingdom, we process personal data on the bases of: (a) performance of a contract; (b) your consent; (c) our legitimate interests in operating and improving the service; (d) compliance with legal obligations.",
  },
  {
    h: "4. Sharing of Information",
    p: "We do not sell personal information. We share data only with: (a) service providers under contractual confidentiality (cloud hosting, email delivery, payment processing); (b) lenders and credit-data partners strictly as required to fulfill a Funding Portal application you submit; (c) authorities when required by law; (d) successors in the event of a merger or acquisition.",
  },
  {
    h: "5. Data Retention",
    p: "We retain personal information for as long as your account is active or as needed to provide services, comply with legal obligations, resolve disputes, and enforce agreements. You may request deletion of your data at any time by writing to the editorial desk.",
  },
  {
    h: "6. Your Rights",
    p: "Subject to applicable law (including GDPR and CCPA), you have the right to access, correct, delete, or port your personal data; to restrict or object to processing; to withdraw consent; and to lodge a complaint with a supervisory authority. To exercise these rights, contact us via the Contact page.",
  },
  {
    h: "7. Cookies & Tracking",
    p: "We use cookies and similar technologies to keep you signed in, remember your preferences, and measure aggregate usage. You can disable cookies in your browser, though some features may not function correctly. We do not use cross-site advertising trackers.",
  },
  {
    h: "8. Security",
    p: "We implement administrative, technical, and physical safeguards designed to protect your personal information — including encryption in transit (TLS), encryption at rest for sensitive fields, access controls, and logging. No system is perfectly secure; we cannot guarantee absolute security.",
  },
  {
    h: "9. Children's Privacy",
    p: "Our services are not directed to children under 18. We do not knowingly collect personal information from children. If we learn we have collected such data, we will delete it promptly.",
  },
  {
    h: "10. International Transfers",
    p: "Your information may be processed in the United States and other jurisdictions. Where required, we implement appropriate safeguards (Standard Contractual Clauses, adequacy decisions) for cross-border transfers of personal data.",
  },
  {
    h: "11. Funding Portal & Credit Data",
    p: "When you submit a Funding Portal application, we may obtain, with your explicit consent, soft-pull credit data, business credit reports (DUNS, Paydex, SBFE), and NAICS-related risk indicators. This data is used only to generate your personalized funding analysis and is never sold.",
  },
  {
    h: "12. Changes to This Policy",
    p: "We may update this Privacy Policy from time to time. Material changes will be notified by email or via a prominent notice on the website. The 'Effective' date below indicates the most recent revision.",
  },
  {
    h: "13. Contact",
    p: "Questions, requests, or complaints regarding privacy? Email us at support@wealthfirstinc.tv or use the Contact page. We respond to verified requests within 30 days.",
  },
];

export default function Privacy() {
  return (
    <div data-testid="privacy-page" className="max-w-[900px] mx-auto px-6 lg:px-10 pt-32 pb-24">
      <div className="mb-12 reveal">
        <p className="eyebrow mb-4">Legal</p>
        <h1 className="font-display text-6xl md:text-7xl mb-4 leading-[0.95]">Privacy Policy</h1>
        <p className="text-sm uppercase tracking-[0.18em]" style={{ color: "var(--ink-faint)" }}>
          Effective {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}
        </p>
      </div>
      <hr className="hairline mb-10" />
      <div className="space-y-10">
        {SECTIONS.map((s) => (
          <section key={s.h}>
            <h2 className="font-display text-2xl mb-3">{s.h}</h2>
            <p className="text-base leading-[1.85]" style={{ color: "var(--ink-muted)" }}>{s.p}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
